export default "__VITE_ASSET__qXXUKCwf__"